import { useLocation } from 'react-use';

export default function useUrlSearchParam(key: string) {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  return params.get(key);
}
